export type CrawlMode = 'http' | 'browser';

export function getCagentAuthHeaders(): Record<string, string> {
  const dataLogin = localStorage.getItem('dataLogin');
  if (!dataLogin) {
    return {};
  }

  try {
    const parsed = JSON.parse(dataLogin) as { accessToken?: string };
    if (parsed.accessToken) {
      return { Authorization: `Bearer ${parsed.accessToken}` };
    }
  } catch {
    return {};
  }

  return {};
}

export function resolveCrawlEndpoints(
  apiBaseUrl: string,
  rootUrlHostApi?: string,
): { submitUrl: string; statusUrl: (jobId: string) => string; useCagentAuth: boolean } {
  if (rootUrlHostApi) {
    const base = rootUrlHostApi.replace(/\/$/, '');
    return {
      submitUrl: `${base}/crawl`,
      statusUrl: (jobId: string) => `${base}/crawl/${jobId}`,
      useCagentAuth: true,
    };
  }

  return {
    submitUrl: `${apiBaseUrl}/api/crawl`,
    statusUrl: (jobId: string) => `${apiBaseUrl}/api/crawl/${jobId}`,
    useCagentAuth: false,
  };
}
